import React from 'react';

export const SearchIcon = () => {
  return <div data-testid="search-icon" className="vbz-icon-corporates-club-search" />;
};
